import AllApplication from '@icon-park/react/lib/icons/AllApplication';
import CheckSmall from '@icon-park/react/lib/icons/CheckSmall';
import History from '@icon-park/react/lib/icons/History';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { RECOMMEND_COLORS } from './const';
import { StashStore, toHex } from './utils';
var ALLOW_REG = /[^0-9|a-f|A-F]/g;
var colorIsEqual = function (color1, color2) { return toHex(color1) === toHex(color2); };
var renderTitle = function (title) { return React.createElement("h5", { className: "syl-dropdown-list-title color" }, title); };
var renderColorSpan = function (color, resetColor, selectedColor) {
    if (selectedColor === void 0) { selectedColor = ''; }
    return (React.createElement("span", { className: classnames('syl-color-span-wrapper', { selected: colorIsEqual(color, selectedColor) }), key: color, "data-color": color },
        React.createElement("span", { style: { backgroundColor: color }, className: classnames('syl-color-span', {
                reset: resetColor === color,
                rim: ['#F8F8F8', '#FFFFFF'].includes(color),
            }) })));
};
var pureColor = function (color) { return color && color.replace(/#/g, ''); };
var InputColor = function (_a) {
    var setColor = _a.setColor, color = _a.color, onChange = _a.onChange;
    var colorStr = pureColor(color);
    return (React.createElement("div", { className: classnames('syl-color-preview-container') },
        React.createElement("span", { className: "syl-color-preview-wrapper" },
            React.createElement("span", { className: "syl-color-span", style: { backgroundColor: "#" + colorStr } })),
        React.createElement("span", { className: "syl-fake-dash" }, "#"),
        React.createElement("input", { spellCheck: false, value: pureColor(color), maxLength: 8, onChange: function (e) { return onChange(e.target.value); }, onFocus: function (e) { return e.target.setSelectionRange(0, colorStr.length); }, onClick: function (e) { return e.stopPropagation(); } }),
        React.createElement("button", { type: "button", onClick: function () {
                setColor("#" + colorStr);
            } },
            React.createElement(CheckSmall, { theme: "outline", size: "18", fill: "#222" }))));
};
var renderPickData = function (data, resetColor) {
    if (!data.length)
        return;
    return (React.createElement(React.Fragment, null,
        renderTitle(React.createElement(History, { theme: "outline", size: "14", fill: "#222" })),
        React.createElement("div", { className: "prev-wrapper" }, data.map(function (color) { return renderColorSpan(color, resetColor); }))));
};
var ColorSelector = function (_a) {
    var name = _a.name, _b = _a.max, max = _b === void 0 ? 10 : _b, onClick = _a.onClick, resetColor = _a.resetColor, selectedColor = _a.selectedColor;
    var _c = useState(null), store = _c[0], setStore = _c[1];
    var _d = useState(selectedColor), inputColor = _d[0], _setInputColor = _d[1];
    useEffect(function () {
        var _store = new StashStore(name, max);
        setStore(_store);
    }, []);
    var setInputColor = function (color) {
        if (color === inputColor) {
            return;
        }
        _setInputColor(color);
    };
    var prevPick = store ? store.data : [];
    var setColor = function (color, force) {
        if (force === void 0) { force = false; }
        var realColor = toHex(color);
        if (!realColor) {
            // remove format when empty
            if (color === '#')
                onClick(false, force);
            return;
        }
        setInputColor(color);
        onClick(color === resetColor ? false : realColor, force);
        store && store.add(realColor, true);
    };
    return (React.createElement("div", { className: "syl-dropdown-wrapper" },
        React.createElement("div", { className: "syl-color-list-wrapper", onClick: function (e) {
                var target = e.target;
                if (target && target.dataset && target.dataset.color) {
                    setColor(target.dataset.color);
                }
            } },
            renderPickData(prevPick, resetColor),
            renderTitle(React.createElement(AllApplication, { theme: "outline", size: "14", fill: "#222" })),
            React.createElement("div", { className: "syl-color-recommend" }, RECOMMEND_COLORS.map(function (color) { return renderColorSpan(color, resetColor, selectedColor); })),
            React.createElement("div", { className: "dropdown-hr" }),
            React.createElement(InputColor, { setColor: function (_color) {
                    setColor(_color, true);
                }, color: inputColor, onChange: function (val) {
                    setInputColor(val.replace(ALLOW_REG, ''));
                } }))));
};
export { ColorSelector };
//# sourceMappingURL=color-selector.js.map